import _Typography from './Typography';

import './style/index.js';

export * from './type';

export const Typography = _Typography;
export default Typography;
